import { AbstractControl, ValidatorFn } from '@angular/forms';
import { EMAIL_REGEX, VALIDATOR_MAP } from './fn-form.constant';
import { FnInputModel } from './fn-input.model';
import { FnI18nService } from '../../i18n/fn-i18.service';
import { isNotNull } from './../../util/check';

/**
 
 * Method used to validate FormControl by the given pattern.
 * @param i18nSvcs FnI18nService refernce to get the Error message in user selected language.
 * @param config FnInputModel object to get pattern and alse to get name of FormControl.
 * @returns null if valid else return Object with key valid false And message of user selected language.
 */
export function FnPatternValidator(i18nSvcs: FnI18nService, config: FnInputModel): ValidatorFn {
  return (control: AbstractControl) => {
    const pattern = new RegExp(`^${config.pattern}$`);
    if ((pattern).test(control.value)) {
      return null;
    } else {
      return { valid: false, message: i18nSvcs.errorMessage(VALIDATOR_MAP.EMAIL, config.key) };
    }
  };
}

/**
 
 * Method used to validate Email type Input Field by the pattern given.
 * @param i18nSvcs FnI18nService refernce to get the Error message in user selected language.
 * @param config FnInputModel object to get pattern and alse to get name of FormControl.
 * @returns null if valid else return Object with key valid false And message of user selected language.
 */
export function FnEmailValidator(i18nSvcs: FnI18nService, config: FnInputModel): ValidatorFn {
  return (control: AbstractControl) => {
    const pattern = config.pattern === undefined ? EMAIL_REGEX : new RegExp(`^${config.pattern}$`);
    if ((pattern).test(control.value)) {
      return null;
    } else {
      return { valid: false, message: i18nSvcs.errorMessage(VALIDATOR_MAP.EMAIL, config.key) };
    }
  };
}
/**
 
 * Method used to validate Form Control when isrequired for that field is true.
 * @param i18nSvcs FnI18nService refernce to get the Error message in user selected language.
 * @param config used to get name of FormControl.
 * @returns null if valid else return Object with key valid false And message of user selected language.
 */
export function FnRequireValidator(i18nSvcs: FnI18nService, config: FnInputModel): ValidatorFn {
  return (control: AbstractControl) => {
	const value = control.value;
		if (isNotNull(value) && (control.value + '').trim() !== '') {
      return null;
    } else {
      return { valid: false, message: i18nSvcs.errorMessage(VALIDATOR_MAP.REQUIRED, config.key) };
    }
  };
}

/**
 
 * Method used to validate minimum charcter used can enter in input field.
 * @param i18nSvcs FnI18nService refernce to get the Error message in user selected language.
 * @param config FnInputModel object to get minLength  and alse to get name of FormControl.
 * @returns null if valid else return Object with key valid false And message of user selected language.
 */
export function FnMinValidator(i18nSvcs: FnI18nService, config: FnInputModel): ValidatorFn {
  return (control: AbstractControl) => {
    const value = (control.value || '')+'';
    if (config.isRequired && value.length >= config.minLength) {
      return null;
    } else {
      return { valid: false, message: i18nSvcs.errorMessage(VALIDATOR_MAP.MIN_LENGTH, config.key) };
    }
  };
}

/**
 
 * Method used to validate maximum charcter used can enter in input field.
 * @param i18nSvcs FnI18nService refernce to get the Error message in user selected language.
 * @param config FnInputModel object to get maxLength  and alse to get name of FormControl.
 * @returns null if valid else return Object with key valid false And message of user selected language.
 */
export function FnMaxValidator(i18nSvcs: FnI18nService, config: FnInputModel): ValidatorFn {
  return (control: AbstractControl) => {
    const value = (control.value || '')+'';
    if (config.maxLength >= value.length) {
      return null;
    } else {
      return { valid: false, message: i18nSvcs.errorMessage(VALIDATOR_MAP.MAX_LENGTH, config.key) };
    }
  };
}


// import {
//     AbstractControl,
//     AsyncValidatorFn,
//     Validator,
//     Validators,
//     ValidatorFn,
// } from '@angular/forms';

// import { of } from 'rxjs';


// export interface ValidationResult { [validator: string]: string | boolean; }

// export type AsyncValidatorArray = Array<Validator | AsyncValidatorFn>;

// export type ValidatorArray = Array<Validator | ValidatorFn>;

// const normalizeValidator =
//     (validator: Validator | ValidatorFn): ValidatorFn | AsyncValidatorFn => {
//         const func = (validator as Validator).validate.bind(validator);
//         if (typeof func === 'function') {
//             return (c: AbstractControl) => func(c);
//         } else {
//             return <ValidatorFn | AsyncValidatorFn>validator;
//         }
//     };

// export const composeValidators =
//     (validators: ValidatorArray): AsyncValidatorFn | ValidatorFn => {
//         if (validators == null || validators.length === 0) {
//             return null;
//         }
//         return Validators.compose(validators.map(normalizeValidator));
//     };

// export const validate =
//     (validators: ValidatorArray, asyncValidators: AsyncValidatorArray) => {
//         return (control: AbstractControl) => {
//             const synchronousValid = () => composeValidators(validators)(control);

//             if (asyncValidators) {
//                 const asyncValidator = composeValidators(asyncValidators);

//                 return asyncValidator(control).map(v => {
//                     const secondary = synchronousValid();
//                     if (secondary || v) { // compose async and sync validator results
//                         return Object.assign({}, secondary, v);
//                     }
//                 });
//             }

//             if (validators) {
//                 return of(synchronousValid());
//             }

//             return of(null);
//         };
//     };

// export const message = (validator: ValidationResult, key: string): string => {
//     switch (key) {
//         case 'required':
//             return 'Please enter a value';
//         case 'pattern':
//             return 'Value does not match required pattern';
//         case 'minlength':
//             return 'Value must be N characters';
//         case 'maxlength':
//             return 'Value must be a maximum of N characters';
//     }

//     switch (typeof validator[key]) {
//         case 'string':
//             return <string>validator[key];
//         default:
//             return `Validation failed: ${key}`;
//     }
// };
